import { combineReducers } from '@reduxjs/toolkit';
import { PLACEHOLDER } from './types';
import { default as app } from './app';
import { default as dependencies } from './dependencies';
import { default as documents } from './documents';
import { default as file } from './file';
import { default as site } from './site';
import { default as tagmanager } from './tagmanager';
import { default as ui } from './ui';
import { default as upload } from './upload';
var onUploadSuccess = function onUploadSuccess() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return state;
};
var affiliateConfig = function affiliateConfig() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return state;
};
var onAuthUpdate = function onAuthUpdate() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return state;
};
var authApiUrl = function authApiUrl() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PLACEHOLDER;
  return state;
};
var editorBaseUrl = function editorBaseUrl() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return state;
};
var wtaiUploadUrl = function wtaiUploadUrl() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return state;
};
var wtaiExpressUrl = function wtaiExpressUrl() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return state;
};
var rootReducer = combineReducers({
  app: app,
  dependencies: dependencies,
  documents: documents,
  file: file,
  site: site,
  tagmanager: tagmanager,
  ui: ui,
  upload: upload,
  onUploadSuccess: onUploadSuccess,
  affiliateConfig: affiliateConfig,
  onAuthUpdate: onAuthUpdate,
  authApiUrl: authApiUrl,
  editorBaseUrl: editorBaseUrl,
  wtaiUploadUrl: wtaiUploadUrl,
  wtaiExpressUrl: wtaiExpressUrl
});
export default rootReducer;